/** Assigned claims use Id membership; Checked is catalogue metadata, not an access flag. */
export interface ConfigurationUser { id?:string; userName?:string; waterFactoryId?:string; }
export interface ConfigurationClaim { id:string; }
export type ConfigurationModule = 'customerCodes'|'integrations'|'contracts'|'routing';
export type ConfigurationAction = 'view'|'edit'|'verify';
export interface ModuleAccess {view:boolean;edit:boolean;verify:boolean;}
export function configurationPermissions(user:ConfigurationUser|null|undefined,claims:readonly ConfigurationClaim[]) {
 const ids=new Set(claims.map(claim=>claim.id));
 const selected=!!user?.waterFactoryId;
 const admin=selected&&(user?.userName?.toLowerCase()==='admin'||ids.has('Admin'));
 const module=(prefix:string,verifiable=false):ModuleAccess=>{const view=selected&&(admin||ids.has(prefix+'.View'));return {view,edit:view&&(admin||ids.has(prefix+'.Edit')),verify:verifiable&&view&&(admin||ids.has(prefix+'.Verify'))};};
 return {customerCodes:module('CustomerCodeSettings'),integrations:module('FactoryIntegrationSettings'),contracts:module('ElectronicContractSettings'),routing:module('EInvoiceRouting',true)};
}
